import {
  UTENTE_AUTENTICATO,
  UTENTE_DISCONNESSO
} from 'Actions/ossif/ossifTypes'

const INIT_STATE = {
  utente: null
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UTENTE_AUTENTICATO:
      return {
        ...state,
        utente: action.payload
      }
    case UTENTE_DISCONNESSO:
      return {
        ...state,
        utente: null
      }
    default:
      return { ...state }
  }
}
